import React from 'react';

import styles from './PopupForm.module.scss';

interface Props {
  visible?: boolean;
  text?: string;
}

const PopupFormErrorMessage = ({ visible, text }: Props) => (
  <p
    className={styles.popup_form__error_message}
    style={{ visibility: visible ? 'visible' : 'hidden' }}
  >
    {text}
    &nbsp;
  </p>
);

PopupFormErrorMessage.defaultProps = {
  visible: true,
  text: '',
};

export default PopupFormErrorMessage;
